import { default as UpNextV2EventList } from './UpNextV2EventList';
import { observer } from 'mobx-react-lite';
import { getLoadState } from 'owa-calendar-events-loader';
import {
    getUpNextCalendarEvent,
    getUpNextConflictingCalendarEvents,
} from 'owa-upnext-event-loader';
import * as React from 'react';

const UpNextCalendarCacheScenarioId = 'TimePanelAgenda_UpNextCalendarCacheId';
export interface UpNextV2WrapperProps {
    containerStyle: any;
}

/**
 * Gets the UpNext event for the UpNext scenario id which is shared between TimePanel
 * and UpNext so that both scenarios show the same event as up-coming
 */
function getUpNextEvent() {
    /**
     * We can only get the UpNext event when the events for the UpNext calendars
     * and date range are loaded in the calendar store/cache
     */
    if (getLoadState(UpNextCalendarCacheScenarioId) == 'Loaded') {
        return getUpNextCalendarEvent(UpNextCalendarCacheScenarioId);
    }

    return null;
}

export default observer(function UpNextV2Wrapper(props: UpNextV2WrapperProps) {
    // Show nothing if there is no up-next event
    const upNextEvent = getUpNextEvent();
    if (!upNextEvent) {
        return null;
    }

    const conflictingEvents = getUpNextConflictingCalendarEvents(UpNextCalendarCacheScenarioId);

    return (
        <UpNextV2EventList
            upNextEvent={upNextEvent}
            conflictingEvents={conflictingEvents}
            containerStyle={props.containerStyle}
        />
    );
});
